<template>
    <ul class="booking-pagination">
        <li v-bind:class="{ active: step == index }"  class="point" v-for="index in total" :key="index">
        
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        step: Number,
        total: Number
    }
}
</script>